





























import { computed, defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useUserVerification from "@/hooks/useUserVerification";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BasePage from "@/components/BasePage";
import PayeeInfoSetupView from "./components/PayeeInfoSetupView.vue";

export default defineComponent({
  name: "PageBecomeCreator",
  components: { PayeeInfoSetupView, BasePage, BaseConfirm, BaseButton },
  setup(_, { root }) {
    const { findMyStatus } = useUserVerification();
    const { userVerified } = useAuthUser();

    const showContractConfirm = ref(false);

    const showSetup = computed(() => !userVerified.value);
    const creatorContractUrl = computed(() => config.creatorContractUrl);

    const goToProfilePayeeInfo = () => {
      root.$router.replace({ name: "profilePayeeInfo" });
    };

    const handleSuccessVerify = async (promise: Promise<void>) => {
      await promise;
      if (creatorContractUrl.value) showContractConfirm.value = true;
      else goToProfilePayeeInfo();
    };

    const handleAfterVerify = () => {
      showContractConfirm.value = false;
      goToProfilePayeeInfo();
    };

    findMyStatus().then(() => {
      if (userVerified.value) goToProfilePayeeInfo();
    });

    return {
      showSetup,
      creatorContractUrl,
      showContractConfirm,
      handleSuccessVerify,
      handleAfterVerify,
    };
  },
});
